module.exports = __webpack_public_path__ + "img/shipping-box.2032e58c.svg";